import { render, staticRenderFns } from "./flowXStockIndex.vue?vue&type=template&id=377c427a&scoped=true"
import script from "./flowXStockIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./flowXStockIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./flowXStockIndex.vue?vue&type=style&index=0&id=377c427a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377c427a",
  null
  
)

export default component.exports